import { FORM_VALUES, MAX_INT_VALUE } from './constants';

const isFieldEmpty = (values, field) =>
  values[field] === undefined || values[field] === '';

const validatePositiveNumber = value =>
  Number(value) > 0 && Number(value) <= MAX_INT_VALUE;

const getPositiveNumberError = field => (values, t) => {
  if (isFieldEmpty(values, field)) return t('new_ad.required');
  return Number(values[field]) < 1
    ? t('new_ad.above_zero')
    : t('new_ad.less_than', { value: MAX_INT_VALUE + 1 });
};

const validateInterestRate = value => Number(value) > 0 && Number(value) <= 100;

const getInterestRateError = (values, t) => {
  if (isFieldEmpty(values, FORM_VALUES.interestRate))
    return t('new_ad.required');
  return Number(values[FORM_VALUES.interestRate]) < 1
    ? t('new_ad.above_zero')
    : t('new_ad.less_than', { value: 101 });
};

export const mortgageValidatorsConfig = {
  [FORM_VALUES.firstPayment]: {
    required: values => !!values[FORM_VALUES.hasNewMortgage],
    validator: validatePositiveNumber,
    errorMessage: getPositiveNumberError(FORM_VALUES.firstPayment)
  },
  [FORM_VALUES.monthlyPayment]: {
    required: values => !!values[FORM_VALUES.hasNewMortgage],
    validator: validatePositiveNumber,
    errorMessage: getPositiveNumberError(FORM_VALUES.monthlyPayment)
  },
  [FORM_VALUES.interestRate]: {
    required: values => !!values[FORM_VALUES.hasNewMortgage],
    validator: validateInterestRate,
    errorMessage: getInterestRateError
  },
  [FORM_VALUES.remainYears]: {
    required: values => !!values[FORM_VALUES.hasNewMortgage],
    errorMessage: 'new_ad.required'
  },
  [FORM_VALUES.remainMonths]: {
    required: values => !!values[FORM_VALUES.hasNewMortgage],
    errorMessage: 'new_ad.required'
  }
};

export const getMortgagePrice = values =>
  values[FORM_VALUES.hasNewMortgage]
    ? Number(values[FORM_VALUES.firstPayment])
    : Number(values[FORM_VALUES.price]);

export const getMortgageTerms = values => {
  if (!values[FORM_VALUES.hasNewMortgage]) return undefined;

  const terms = {
    monthlyPayment: Number(values[FORM_VALUES.monthlyPayment]),
    interestRate: Number(values[FORM_VALUES.interestRate]),
    remainingYears: Number(values[FORM_VALUES.remainYears]) || 0
  };

  const remainMonths = values[FORM_VALUES.remainMonths];
  if (remainMonths != null && remainMonths !== '') {
    terms.remainingMonths = Number(remainMonths);
  }

  return terms;
};
